import {BOOKING_ACTION} from '../constants/bookingIntents'
import {isUnifiedEntryEnabled} from '../constants/bookingFeatureFlags'

/**
 * BCL-001 entry inventory (normal therapy booking):
 * - DoctorWidget.confirmSession -> legacy writer (convert when flag on)
 * - SessionsView.sendSessionRequest -> legacy writer (convert when flag on)
 * - SelectCycle.confirm -> legacy writer in package reserve flow (convert when flag on)
 * - SelectDateTimeSession (sessions-request route) -> legacy writer (convert when flag on)
 * - Nav / UserSelectDoctor / UserSessionStatus -> navigation only (unify route)
 * - UserJourney CTAs -> canonical shell (normalize intent query)
 * Excluded: presession/triage (selectTimeForPreSession, triage-request, presession views)
 */

// BCL-003 seam: load canonical booking context before rendering CTAs.
// export function loadBookingContext() {}

export function resolveBookingLang(router, intent = {}) {
  return intent.lang
    || (router && router.currentRoute && router.currentRoute.params && router.currentRoute.params.lang)
    || 'fa'
}

export function parseBookingIntent(route) {
  const query = (route && route.query) || {}

  return {
    source: query.source || null,
    action: query.action || BOOKING_ACTION.START,
    therapistId: query.therapistId || null,
    packageId: query.package_id || null,
    refferId: query.reffer_id || null,
  }
}

export function buildUserJourneyRoute(intent = {}, lang = 'fa') {
  const query = {}

  if (intent.source) {
    query.source = intent.source
  }
  if (intent.action) {
    query.action = intent.action
  }
  if (intent.therapistId) {
    query.therapistId = intent.therapistId
  }
  if (intent.packageId) {
    query.package_id = intent.packageId
  }
  if (intent.refferId) {
    query.reffer_id = intent.refferId
  }

  if (intent.extraQuery && typeof intent.extraQuery === 'object') {
    Object.keys(intent.extraQuery).forEach((key) => {
      if (intent.extraQuery[key] != null && intent.extraQuery[key] !== '') {
        query[key] = intent.extraQuery[key]
      }
    })
  }

  return {
    name: 'userJourney',
    params: {lang},
    query,
  }
}

export function getBookingEntryRoute(intent = {}, lang = 'fa') {
  if (isUnifiedEntryEnabled()) {
    return buildUserJourneyRoute(intent, lang)
  }

  return {name: 'sessions-request'}
}

export function startBooking(router, intent = {}) {
  if (!isUnifiedEntryEnabled()) {
    return false
  }

  const lang = resolveBookingLang(router, intent)
  router.push(buildUserJourneyRoute(intent, lang))
  return true
}

export function assertNotDirectWrite(caller) {
  if (process.env.NODE_ENV === 'production') {
    return
  }

  if (isUnifiedEntryEnabled()) {
    console.warn(`[booking] Direct legacy booking write blocked (${caller}). Use bookingOrchestrator.start().`)
  }
}
